;
(function($, $win) {
	var CoverController = (function() {
		var blocks = [];

		return {
			init: function() {
				$win.on('load.BlockCover resize.BlockCover orientationchange.BlockCover', this.resizeHandler.bind(this));

				this.resizeObserver = new ResizeObserver(this.resizeHandler.bind(this));

				this.resizeObserver.observe(document.body);
			},

			resizeHandler: function() {
				if (this.isInit) {
					$.each(blocks, this.resizeBlock.bind(this));
				}
			},

			resizeBlock: function(i) {
				var item = blocks[i];
				var styles = this.getDimensions({
					blockRatio: item.ratio,
					maskWidth: item.$holder.outerWidth(),
					maskHeight: item.$holder.outerHeight()
				});

				item.$block.css({
					width: styles.width,
					height: styles.height,
					marginTop: styles.top,
					marginLeft: styles.left
				});
			},

			getRatio: function($block) {
				return $block[0].width / $block[0].height ||
					$block.attr('width') / $block.attr('height') ||
					$block.width() / $block.height();
			},

			getDimensions: function(data) {
				var ratio = data.blockRatio,
					slideWidth = data.maskWidth,
					slideHeight = slideWidth / ratio;

				if (slideHeight < data.maskHeight) {
					slideHeight = data.maskHeight;
					slideWidth = slideHeight * ratio;
				}
				return {
					width: slideWidth,
					height: slideHeight,
					top: (data.maskHeight - slideHeight) / 2,
					left: (data.maskWidth - slideWidth) / 2
				};
			},

			add: function($block, options) {
				var $holder = options.holder ? $block.closest(options.holder) : $block.parent();
				var item = {
					$block: $block,
					$holder: $holder,
					options: options
				};

				this.onReady(item);


				this.makeCallback.apply($.extend(true, {}, this, item), ['onInit']);
				return this;
			},

			onReady: function(item) {
				if (!this.isInit) {
					this.isInit = true;
					this.init();
				}
				blocks.push($.extend(item, {
					ratio: this.getRatio(item.$block)
				}));
				this.resizeBlock(blocks.length - 1);
			},

			destroy: function($block) {
				if (!$block) {
					blocks = blocks.filter(this.destroySingle);
				} else {
					blocks = blocks.filter(function(item) {
						var removeFlag = item.$block.is($block);

						removeFlag && this.destroySingle(item);

						return !removeFlag;
					}.bind(this));
				}

				if (!blocks.length) {
					this.isInit = false;
					$win.off('.BlockCover');
					this.resizeObserver.unobserve(document.body);
				}

			},

			destroySingle: function(item) {
				item.$block.removeAttr('style').removeData('BlockCover');
			},

			makeCallback: function(name) {
				if (typeof this.options[name] === 'function') {
					var args = Array.prototype.slice.call(arguments);
					args.shift();
					this.options[name].apply(this, args);
				}
			}
		};
	}());

	$.fn.blockCover = function(opt) {
		var args = Array.prototype.slice.call(arguments);
		var method = args[0];
		var options = $.extend({
			holder: null
		}, opt);

		return this.each(function() {
			var $block = jQuery(this);
			var instance = $block.data('BlockCover');

			if (typeof opt === 'object' || typeof opt === 'undefined') {
				$block.data('BlockCover', CoverController.add($block, options));
			} else if (typeof method === 'string' && instance) {
				if (typeof instance[method] === 'function') {
					args.shift();
					instance[method].apply(instance, args);
				}
			}
		});
	};

	window.CoverController = CoverController;

	return CoverController;
}(jQuery, jQuery(window)));